import React from 'react';
import { useApp } from '../context/AppContext';
import styles from './Notification.module.css';
import Icon from '../components/Icon';

const Notification = () => {
  const { notification } = useApp();

  if (!notification.show) return null;

  return (
    <div
      className={`${styles.notification} ${styles[notification.type]} ${styles.show}`}
      role={notification.type === 'error' ? 'alert' : 'status'}
    >
      <div className={styles.notificationIcon} aria-hidden="true">
        {notification.type === 'success' && <Icon name="check_circle" />}
        {notification.type === 'error' && <Icon name="error" />}
        {notification.type === 'warning' && <Icon name="warning" />}
      </div>
      <div className={styles.notificationMessage}>
        {notification.message}
      </div>
    </div>
  );
};

export default Notification;
